import React, { useState } from 'react';
import { ModernButton } from '../ui/ModernButton';
import { ArrowLeftIcon } from '../ui/Icons';

export function CreateCampaignPage({ onBack, onCreateCampaign }) {
    const [newCampaign, setNewCampaign] = useState({
        name: '',
        color: 'bg-blue-500',
        enableQuizScoring: false
    });

    const handleCreate = () => {
        if (!newCampaign.name.trim()) return;
        
        const campaign = {
            id: `campaign_${Date.now()}`,
            name: newCampaign.name.trim(),
            applicantCount: 0,
            color: newCampaign.color,
            status: "online", // New campaigns start as online
            landingPage: null,
            applicants: [],
            enable_quiz_scoring: newCampaign.enableQuizScoring
        };
        
        onCreateCampaign(campaign);
        onBack();
    };

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
            {/* Header */}
            <div className="bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between py-6">
                        <div className="flex items-center space-x-4">
                            <ModernButton
                                onClick={onBack}
                                variant="secondary"
                                size="sm"
                                icon={<ArrowLeftIcon className="w-4 h-4" />}
                            >
                                Zurück
                            </ModernButton>
                            <div>
                                <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
                                    Neue Kampagne erstellen
                                </h1>
                                <p className="text-slate-600 dark:text-slate-400">
                                    Erstelle eine neue Kampagne für deine Bewerbungen
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700">
                    <div className="p-8 space-y-6">
                        {/* Campaign Name */}
                        <div>
                            <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-3">
                                Kampagnenname *
                            </label>
                            <input
                                type="text"
                                value={newCampaign.name}
                                onChange={(e) => setNewCampaign(prev => ({ ...prev, name: e.target.value }))}
                                className="w-full px-4 py-3 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-lg"
                                autoFocus
                            />
                        </div>

                        <div className="flex items-center justify-between gap-4 rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-700/50 px-4 py-3">
                            <div>
                                <p className="text-sm font-medium text-slate-700 dark:text-slate-200">Quiz-Scoring aktivieren</p>
                                <p className="text-xs text-slate-500 dark:text-slate-400">Optional Eignungsbewertung nach Abschluss anzeigen</p>
                            </div>
                            <input
                                type="checkbox"
                                checked={newCampaign.enableQuizScoring}
                                onChange={(e) => setNewCampaign(prev => ({ ...prev, enableQuizScoring: e.target.checked }))}
                                className="toggle toggle-primary"
                            />
                        </div>



                    </div>

                    {/* Footer */}
                    <div className="px-8 py-2 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-700/50 rounded-b-xl">
                        <div className="flex justify-end space-x-4">
                            <ModernButton
                                onClick={onBack}
                                variant="secondary"
                                className="px-6 py-3"
                            >
                                Abbrechen
                            </ModernButton>
                            <ModernButton
                                onClick={handleCreate}
                                variant="primary"
                                disabled={!newCampaign.name.trim()}
                                className="px-6 py-3"
                            >
                                Kampagne erstellen
                            </ModernButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
